import {AppContext} from "../../../lib/AppContext";
import React, {useContext, useEffect, useState} from "react";
import {formatCurrency} from "../../common/Utils";
import {addToCart, getCafeInventory, getInventory, getInventoryEvent} from "../../common/api/PortalCustomerApi";
import {Card, CardContent, Grid} from "@mui/material";
import MDBox from "../../../components/MDBox";
import MDButton from "../../../components/MDButton";
import ViewInventoryModal from "../modal/ViewInventoryModal";
import {CartContext} from "../../../lib/CartProvider";
import FileSelector from "./calendarUI/FilterSelector";
import TextField from "@mui/material/TextField";
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';

export default function CustomerCafePane({handleSave}) {
  const [context, setContext] = useContext(AppContext);
  const [cartContext, setCartContext] = useContext(CartContext);

  const [eventReady, setEventReady] = useState(false);
  const [event, setEvent] = useState();
  const [inventoryList, setInventoryList] = useState([]);
  const [renderIndex, setRenderIndex] = useState(1);

  useEffect(() => {
    getCafeInventoryFn();
  }, []);

  const [inventory, setInventory] = useState();
  const [showInventoryModal, setShowInventoryModal] = useState(false);
  const [savingMembership, setSavingMembership] = useState(false);
  const [brands, setBrands] = useState([]);
  const [brandsReady, setBrandsReady] = useState(false);

  const [inventoryTypes, setInventoryTypes] = useState([]);


  const getInventoryEventFn = async (eventId) => {
    getInventoryEvent(eventId).then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setEvent(result);
        setEventReady(true);
      }
    });
  }

  const [inventoryType, setInventoryType] = useState();

  const handleClose = () => {
    setShowInventoryModal(false);
  };

  const getInventoryFn = async () => {
    let result = await getInventory();
    setInventoryList(result);

    let _brands = [];
    for (let r in result) {
      let _brand = result[r].brand;
      if (_brand.id > -1 && _brands.filter(b => b.id === _brand.id).length === 0) {
        _brands.push(_brand);
      }
    }
    setBrands(_brands);
    setBrandsReady(true);
  }

  const getCafeInventoryFn = async () => {
    let result = await getCafeInventory();

    if (result) {
      let _brands = [];
      for (let r in result) {
        let _brand = result[r].brand;
        if (_brand && _brand?.id > -1 && _brands.filter(b => b.id === _brand.id).length === 0) {
          _brands.push(_brand);
        }
      }
      setBrands(_brands);
      setBrandsReady(true);


      let _types = []
      let _inventoryTypes = []
      for (let j in result) {
        if (result[j].inventoryType != null && result[j].inventoryType?.id > 0) {
          if (_types.indexOf(result[j].inventoryType.id) == -1) {
            _types.push(result[j].inventoryType.id);
            _inventoryTypes.push(result[j].inventoryType);
          }
        }
      }
      setInventoryTypes(_inventoryTypes);
      setInventoryList(result);
    }
  }

  const viewInventory = (e) => {
    setInventory(e);
    setShowInventoryModal(true);
  };

  const loadCartFn = () => {

    setCartContext({...cartContext, reloadCart: true, caller: 'Customer Store pane'});

    let _context = {...context};
    _context.toast = {
      message: 'Added to cart!',
      type: 'success'
    }
    setContext({..._context});
  };

  const addToCartFn = async (e) => {
    const resp = await addToCart(event);
    loadCartFn();
  };

  const [brandFilter, setBrandFilter] = useState([]);
  const [searchCriteria, setSearchCriteria] = useState('');

  const toggleBrandFilter = (e) => {
    let _brandFilter = [...brandFilter];
    if (e.target.checked) {
      _brandFilter = [...brandFilter, parseInt(e.target.value, 10)];
    } else {
      _brandFilter.splice(brandFilter.indexOf(parseInt(e.target.value, 10)), 1);
    }
    setBrandFilter(_brandFilter);
    setRenderIndex(renderIndex + 1);
  }

  const filterFn = (item) => {
    if (!searchCriteria || !searchCriteria.length) {
      return true;
    }
    let crit = item.name.toLowerCase();
    let match = crit.match(searchCriteria.toLowerCase());
    if (match && match.length > 0) {
      return true;
    }

    crit = item.desc.toLowerCase();
    match = crit.match(searchCriteria.toLowerCase());
    if (match && match.length > 0) {
      return true;
    }
    if (match && match.length > 0) {
      return true;
    }
    if (item?.tags?.length > 0) {
      let hasTagMatch = false;
      for (let j in item?.tags) {
        crit = item?.tags[j].name.toLowerCase();
        match = crit.match(searchCriteria.toLowerCase());
        if (match && match.length > 0) {
          return true;
        }
      }
    }

    return false;
  }

  const showItem = (_item) => {
    let show = (brandFilter.length === 0 || brandFilter.indexOf(_item.brand?.id) > -1);
    let orShow = (inventoryTypeFilter.length === 0 || inventoryTypeFilter.indexOf(_item?.inventoryType?.id) > -1);
    if (!show && !orShow) {
      return false;
    }

    return filterFn(_item)
  };

  const ellipsisStyle = {
    display: '-webkit-box',
    WebkitLineClamp: 3,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
  };
  const [inventoryTypeFilter, setInventoryTypeFilter] = useState([]);

  const showInventoryTypeHeader = (type) => {
    if (!inventoryTypeFilter.length) {
      return true;
    }
    for (let f in inventoryTypeFilter) {
      if (inventoryTypeFilter[f] === type.id) {
        return true;
      }
    }
    return false;
  }
  const [sortInventory, setSortInventory] = useState({field: 'name', direction: 'asc'});
  const [inventoryFiltered, setInventoryFiltered] = useState([]);
  useEffect(() => {
    filteredInventory(inventory);
  }, [inventoryTypeFilter]);

  const filteredInventory = (inventories) => {
    let _inventories = [];
    for (let j in inventories) {
      if (showItem(inventories[j])) {
        _inventories.push(inventories[j]);
      }
    }
    setInventoryFiltered(_inventories);
  }
  const sortInventoryFn = (a, b) => {
    const sortDir = sortInventory.direction === 'desc' ? -1 : 1;
    if (sortInventory.field === 'name') {
      return a.name.toUpperCase() > b.name.toUpperCase() ? sortDir : sortDir * -1;
    }
    if (sortInventory.field === 'price') {
      return sortPrice(a, b) ? sortDir : sortDir * -1;
    }
    if (sortInventory.field === 'id') {
      return a.id > b.id ? sortDir : sortDir * -1;
    }
    return a.id > b.id ? sortDir : sortDir * -1;
  }

  const sortPrice = (a, b) => {
    if (a.price === b.price) {
      return a.name.toUpperCase() > b.name.toUpperCase();
    } else {
      return a.price > b.price;
    }
  }

  return (
    <>
      <MDBox>
        <Grid container cols={2} spacing={2} direction="row">
          <Grid item sm={6} xs={6}>
            <TextField type="text"
                       sx={{
                         marginRight: '8px',
                         borderRadius: '0',
                         '& .MuiInputBase-root': {
                           borderRadius: '0',
                         },
                       }}
                       autoComplete={'off'}
                       variant="outlined"
                       value={searchCriteria || ''}
                       onChange={(e) => setSearchCriteria(e.target.value)}
                       className="form-control" id="code" aria-describedby="searchInventory"
                       label="Search Store"/>
          </Grid>
          <Grid item sm={6} xs={6}>
            <FileSelector
              types={brands}
              typeFilter={brandFilter}
              filterLabel={'Brands'}
              setFilter={(filters) => {
                setBrandFilter(filters)
              }}
            />

          </Grid>


          <Grid item xs={12} sm={12}>
            <Grid container spacing={1} style={{
              position: 'sticky',
              top: '-10px',
              zIndex: '999',
              background: '#fff',
              marginTop: "5px",
              padding: '15px 24px',
              borderBottom: '1px solid #E1DEEA',
            }}>
              <div className={'d-block w-100'}>
                <ul className={'nav psb-category-chip-list'}>
                  {inventoryTypes?.sort((a, b) => a.sortOrder - b.sortOrder)?.map((t, idx) => {
                    return (
                      <li key={idx} className={'nav-item'}>
                        <MDButton
                          onClick={(e) => {
                            document.getElementById('t-' + t.id)?.scrollIntoView({behavior: 'smooth'});
                          }}
                          className={'psb-category-chip'}
                          size="small" variant="outlined">{t.name}</MDButton>
                      </li>
                    )
                  })
                  }
                </ul>
              </div>
            </Grid>
          </Grid>

          {inventoryTypes?.filter((t) => showInventoryTypeHeader(t)).sort((a, b) => a.sortOrder - b.sortOrder)?.map((t, idx) => {
            return (
              <div className={'d-block my-2 pt-4'} style={{
                display: 'block',
                width: '100%',
                margin: '20px',
                paddingTop: '20px'
              }} key={idx} id={'t-' + t.id}>
                <h5>{t.name}</h5>
                <Grid container spacing={2} key={idx}>

                  {inventoryList?.length > 0 && inventoryList?.filter((item) => item.inventoryType.id === t.id).sort((a, b) => sortInventoryFn(a, b)) //
                    .map((inventory, index) => {
                      return (
                        <Grid item md={6} sm={12} xs={12} key={index}
                              className={'d-inline-grid'}>
                          <div className={'psb-bordered psb-carded'}>
                            <Grid>
                              <Grid container spacing={3}>
                                <Grid item xs={12} sm={3}>
                                  {inventory?.imageUrl ? <img
                                    style={{
                                      maxWidth: '95%',
                                      height: 'auto',
                                      borderRadius: '12px'
                                    }}
                                    alt={inventory.name}
                                    src={inventory?.imageThumbUrl || inventory?.imageUrl}
                                  /> : <>&nbsp;</>
                                  }
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                  <h4 style={{
                                    fontWeight: 'bold',
                                  }}>{inventory.name}</h4>
                                  {inventory.brand?.id > -1 && <h5>{inventory.brand?.name}</h5>}

                                  <p style={{
                                    fontSize: "0.85rem",
                                    whiteSpace: 'pre-wrap',
                                    ...ellipsisStyle
                                  }}>
                                    {inventory.desc}
                                  </p>
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                  <MDBox display="flex" justifyContent={{xs: 'flex-start', sm: 'flex-end'}}>
                                    <p>
                                      <b>{formatCurrency(inventory?.price)}</b>
                                    </p>
                                  </MDBox>
                                </Grid>
                              </Grid>
                            </Grid>
                            <Grid container>
                              <Grid item xs={12} alignContent={'flex-end'}>
                                <MDBox display="flex" justifyContent={{xs: 'flex-start', sm: 'flex-end'}}>
                                  <MDButton
                                    size={'small'}
                                    color="secondary"
                                    onClick={(e) => {
                                      viewInventory(inventory);
                                    }}>View Details</MDButton>
                                </MDBox>
                              </Grid>
                            </Grid>
                          </div>
                        </Grid>
                      )
                    })
                  }
                </Grid>
              </div>
            )
          })
          }
        </Grid>
      </MDBox>


      {
        inventory && <ViewInventoryModal
          key={inventory?.guid}
          handleClose={handleClose}
          handleSave={handleSave}
          show={showInventoryModal}
          inventory={inventory}
        />
      }

    </>
  )
}